import * as serviceContext from './serviceContext';


var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function casinoLaunch(gameId) {
    try {
        const response = await serviceContext.get("casino/games/launch/"+gameId, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};